import { render, staticRenderFns } from "./VANStats.vue?vue&type=template&id=55232774&"
import script from "./VANStats.vue?vue&type=script&lang=js&"
export * from "./VANStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55232774')) {
      api.createRecord('55232774', component.options)
    } else {
      api.reload('55232774', component.options)
    }
    module.hot.accept("./VANStats.vue?vue&type=template&id=55232774&", function () {
      api.rerender('55232774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/VANStats.vue"
export default component.exports